import {
  configureStore, ThunkAction, Action, combineReducers,
} from '@reduxjs/toolkit';
import { learningPathwaysSlice } from './slices/learningPathways';
import { learningModulesSlice } from './slices/learningModules';
import { suApiSlice } from './slices/api/su';
import { weblabsSlice } from './slices/weblabs';
import { topicsSlice } from './slices/topics';
import { webinarSlice } from './slices/webinar';

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof makeStore>;
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
AppState,
unknown,
Action<string>
>;

export const rootReducer = combineReducers({
  [suApiSlice.reducerPath]: suApiSlice.reducer,
  [learningPathwaysSlice.name]: learningPathwaysSlice.reducer,
  [learningModulesSlice.name]: learningModulesSlice.reducer,
  [weblabsSlice.name]: weblabsSlice.reducer,
  [topicsSlice.name]: topicsSlice.reducer,
  [webinarSlice.name]: webinarSlice.reducer,
});

export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(suApiSlice.middleware),
  });
};

const store = makeStore();
export default store;
